import { faker } from "@faker-js/faker";

import {
  FindingTriageState,
  IssueStatus,
  Severity,
} from "@protos/common/v1/common";
import {
  AggregateIssueState,
  Issue,
  Issue_ActivityHistoryEvent_HistoryType,
  IssueType,
} from "@protos/issues/v1/issues";

const status = [
  IssueStatus.FIXED,
  IssueStatus.UNRESOLVED,
  IssueStatus.REMOVED,
  IssueStatus.MUTED,
];
const triageStates = [
  FindingTriageState.FIXING,
  FindingTriageState.REOPENED,
  FindingTriageState.IGNORED,
  FindingTriageState.UNTRIAGED,
];
const severities = [Severity.HIGH, Severity.LOW, Severity.MEDIUM];
const historyTypes = [
  Issue_ActivityHistoryEvent_HistoryType.AI_TAG,
  Issue_ActivityHistoryEvent_HistoryType.TRIAGE,
  Issue_ActivityHistoryEvent_HistoryType.AUTOTRIAGE,
  Issue_ActivityHistoryEvent_HistoryType.STATUS,
];
const aggriateStates = [
  AggregateIssueState.FIXED,
  AggregateIssueState.FIXING,
  AggregateIssueState.OPEN,
  AggregateIssueState.REMOVED,
  AggregateIssueState.IGNORED_APP,
  AggregateIssueState.IGNORED_CODE,
  AggregateIssueState.REVIEWING,
];

export const generateFindingData = (
  count: number,
  issueType: IssueType
): Issue[] => {
  const issues: Issue[] = [];
  for (let i = 0; i < count; i++) {
    issues.push(
      Issue.create({
        id: faker.number.int(),
        createdAt: faker.date.recent(),
        activityHistory: [
          {
            date: faker.date.recent(),
            actor: faker.person.fullName(),
            historyType: historyTypes[faker.number.int({ min: 0, max: 3 })],
            note: faker.lorem.sentence(),
            title: faker.lorem.sentence(),
            triageReason: faker.lorem.sentence(),
          },
        ],
        ref: faker.git.branch(),
        syntacticId: faker.git.commitSha(),
        matchBasedId: faker.git.commitSha(),
        aggregateState: aggriateStates[faker.number.int({ min: 0, max: 6 })],
        category: faker.word.noun(),
        firstSeenScan: {
          id: faker.number.int(),
          meta: {
            semgrep_version: faker.number.float(),
            repository: faker.git.branch(),
            repo_url: faker.internet.url(),
            branch: faker.git.branch(),
            ci_job_url: faker.internet.url(),
            commit: faker.git.commitSha(),
            commit_author_email: faker.internet.email(),
            commit_author_name: faker.person.fullName(),
            commit_author_username: faker.internet.userName(),
            commit_author_image_url: faker.image.avatarGitHub(),
            commit_title: faker.git.commitMessage(),
            on: "push",
            pull_request_author_username: null,
            pull_request_author_image_url: null,
            pull_request_id: null,
            pull_request_title: null,
            scan_environment: "github-actions",
            is_full_scan: true,
            ignored_files: [],
          },
        },
        status: status[faker.number.int({ min: 0, max: 3 })],
        severity: severities[faker.number.int({ min: 0, max: 2 })],
        relevantSince: faker.date.recent(),
        repository: {
          name: faker.git.branch(),
          id: faker.number.int(),
          primaryRef: {
            ref: faker.git.branch(),
            id: faker.number.int(),
          },
        },
        triageState: triageStates[faker.number.int({ min: 0, max: 4 })],
        relatedIssues: [],
        lastSeenScan: {
          id: faker.number.int(),
          meta: {
            semgrep_version: faker.number.float(),
            repository: faker.git.branch(),
            repo_url: "",
          },
        },
        rulePath: Array.from(Array(5))
          .map(() => faker.lorem.word())
          .join("."),
        issueParentId: faker.number.int(),
        issueType,
        ruleReferences: [],
        ruleSupersededBy: [],
        ruleUrl: faker.internet.url(),
      })
    );
  }
  return issues;
};
